import { lazy } from 'react';

export const PlayerEmailForm = lazy(() => import('./PlayerEmailForm'));
